import {CSSProperties, Component} from "react";
import * as React from "react";

type PillColour = "red" | "amber" | "green" | "grey" | "black" | "blue";

interface BoolPillProps
{
    value?: boolean;
    
    trueText?: string;
    trueColour?: PillColour;
    
    falseText?: string;
    falseColour?: PillColour;

    style?: CSSProperties;
    classNames?: string;
}

interface BoolPillState
{

}

export default class BoolPill extends Component<BoolPillProps,BoolPillState>
{
    public componentDidMount() {

    }

    public render() {

        const trueText = this.props.trueText || "Yes"; 
        const falseText = this.props.falseText || "No"; 
        const unknownText = "Unknown";

        let text = unknownText;
        if (this.props.value === true) {
            text = trueText;
        }
        else if (this.props.value === false) {
            text = falseText;
        }

        const trueColour = this.props.trueColour || "green";
        const falseColour = this.props.falseColour || "red";
        const unknownColour = "grey";

        let colour = unknownColour;
        if (this.props.value === true) {
            colour = trueColour;
        }
        else if (this.props.value === false) {
            colour = falseColour;
        }

        return (
            <div style={this.props.style} className={`pill pill--${colour} ${this.props.classNames}`}>{text}</div>
        );
    }
}